import React from "react"
import PropTypes from "prop-types"

const ResearchGate = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      role="img"
      fill={color}
      width="280pt"
      height="280pt"
      viewBox="0 0 280 280"
    >
      <g>
        <path
          d="M 9.154624e-6,9.154624e-6 H 279.99998 V 279.99998 H 9.154624e-6 Z M 189.21961,46.698381 c -19.95979,0 -26.79805,14.267183 -26.79805,23.848679 v 25.430395 c 0,12.911435 7.03251,25.248045 25.21633,25.248045 30.52044,-0.0317 26.8258,-23.127188 26.8258,-39.16241 h -23.84868 v 8.416006 h 14.06898 c 0,12.518974 -5.86307,20.931024 -17.01438,20.931024 -8.80452,0 -13.88663,-7.63506 -13.88663,-18.199681 V 72.097062 c 0,-9.783662 9.18111,-15.432663 15.43663,-15.432663 11.15132,0 15.43266,9.779704 15.43266,9.779704 l 8.41602,-5.680715 c 0,0 -4.09503,-14.065007 -23.84868,-14.065007 z m -86.80031,48.06206 c -14.080872,0 -35.578771,1.355762 -55.720919,0.578782 v 6.259487 c 12.134442,2.34681 17.196735,1.16547 17.196735,18.77449 v 86.04314 c 0,17.79534 -5.078145,16.42373 -17.196735,18.77449 v 6.46959 c 5.863061,-0.20217 16.011435,-0.78887 26.369911,-0.78887 9.783672,0 22.508779,0.40038 27.983348,0.78887 v -6.46959 c -15.650689,-2.1486 -20.356206,-0.38848 -20.356206,-18.77449 v -36.36765 c 5.288257,0.3885 9.799524,0.36471 16.832032,0.36471 13.299924,23.86058 26.001244,41.68366 33.235924,50.09967 13.09775,15.83305 34.04462,13.49813 39.1307,11.14735 v -5.86306 c -7.82138,-0.0158 -15.66258,-5.29222 -21.32744,-11.54377 -9.58149,-10.36245 -22.49292,-27.18654 -33.05358,-46.15132 17.60903,-4.3091 30.7147,-20.92706 30.7147,-37.37059 0,-24.63757 -18.9846,-35.971239 -43.80847,-35.971239 z m -4.10296,9.934319 c 18.386,0 29.31929,9.58545 29.31929,27.19446 -0.0158,17.23242 -11.74199,28.74051 -31.293463,28.74051 -7.234685,0 -10.560652,-0.19028 -15.646733,-0.57877 v -54.77743 c 5.086081,-0.59067 11.741984,-0.57877 17.620906,-0.57877 z"
        />
      </g>
    </svg>
  )
}

ResearchGate.propTypes = {
  color: PropTypes.string,
}

ResearchGate.defaultProps = {
  color: "#000000",
}

export default ResearchGate
